import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 5c0-1.1046.8954-2 2-2h4c1.1046 0 2 .8954 2 2v4c0 1.1046-.8954 2-2 2H5c-1.1046 0-2-.8954-2-2zm6 0H5v4h4zm4 0c0-1.1046.8954-2 2-2h4c1.1046 0 2 .8954 2 2v4c0 1.1046-.8954 2-2 2h-4c-1.1046 0-2-.8954-2-2zm6 0h-4v4h4zM3 15c0-1.1046.8954-2 2-2h4c1.1046 0 2 .8954 2 2v4c0 1.1046-.8954 2-2 2H5c-1.1046 0-2-.8954-2-2zm6 0H5v4h4zm4 0c0-1.1046.8954-2 2-2h4c1.1046 0 2 .8954 2 2v4c0 1.1046-.8954 2-2 2h-4c-1.1046 0-2-.8954-2-2zm6 0h-4v4h4z",
    clipRule: "evenodd"
}), "Grid", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
